"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
var System;
(function (System) {
    System["Unknown"] = "unknown";
})(System = exports.System || (exports.System = {}));
